import {useApplications} from '@/hooks/useApplications'
import {useJourneyMetaConfig} from '@/hooks/useJourneyMetaConfig'
import {useAppSelector} from '@/store'
import {selectApplication} from '@/store/slices/commonSlice'

export const useSelectedApplicationCountry = () => {
  const applicationCode = useAppSelector(selectApplication)
  const {country: countryCode} = useJourneyMetaConfig()
  const {applications, ...applicationsQuery} = useApplications()

  const application = applications.find(item => item.code === applicationCode)
  const country = application?.countries.find(item => item.code === countryCode)

  return {
    application,
    country,
    applicationId: application?.id,
    applicationCode: application?.code ?? applicationCode,
    countryId: country?.id ?? -1,
    countryCode: country?.code ?? countryCode,
    countryName: country?.name ?? '',
    ...applicationsQuery,
  }
}
